export default __webpack_public_path__ + "static/media/logo-w-vertical.5e73cdfe.png";